__turbopack_context__.v({
  "contact": "Footer-module-scss-module__zP-c-q__contact",
  "cta": "Footer-module-scss-module__zP-c-q__cta",
  "email": "Footer-module-scss-module__zP-c-q__email",
  "footerColumn": "Footer-module-scss-module__zP-c-q__footerColumn",
  "hideInMobile": "Footer-module-scss-module__zP-c-q__hideInMobile",
  "links": "Footer-module-scss-module__zP-c-q__links",
  "loginButtonContainer": "Footer-module-scss-module__zP-c-q__loginButtonContainer",
  "showInMobile": "Footer-module-scss-module__zP-c-q__showInMobile",
  "telephone": "Footer-module-scss-module__zP-c-q__telephone",
});
